import { render, staticRenderFns } from "./form-report.vue?vue&type=template&id=6d327282&scoped=true&"
import script from "./form-report.vue?vue&type=script&lang=js&"
export * from "./form-report.vue?vue&type=script&lang=js&"
import style0 from "./form-report.vue?vue&type=style&index=0&id=6d327282&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d327282",
  null
  
)

export default component.exports